import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcVolumeonFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 10a2 2 0 0 1 2-2h2.109a1 1 0 0 0 .678-.266l4.66-4.307c.64-.592 1.678-.138 1.678.734v15.654c0 .87-1.036 1.326-1.677.736l-4.661-4.287A1 1 0 0 0 6.11 16H4a2 2 0 0 1-2-2zM16.328 9.415a.75.75 0 0 1 1.017-.3 3.265 3.265 0 0 1 .003 5.736.75.75 0 1 1-.72-1.317 1.765 1.765 0 0 0 0-3.102.75.75 0 0 1-.3-1.017"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.248 5.705a.75.75 0 0 0-.48 1.42 5.131 5.131 0 0 1 .033 9.708.75.75 0 0 0 .49 1.417 6.631 6.631 0 0 0-.043-12.545"
  }));
}
var IcVolumeonFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcVolumeonFill));

export { IcVolumeonFill as I };
